/**
 * Function receiving range, returning random value from that range
 * @param min - minimum value of range
 * @param max - maximum value of range
 */
export const getRandomFromRange = (min: number, max: number): number => {
  return Math.random() * (max - min) + min;
};
